module.exports = __webpack_public_path__ + "img/SKMJ_cover2.71ea2086.jpg";